import { TOTAL_STEPS } from "./wizardUtils";

const STEP_LABELS = [
  "Members",
  "Insured Details",
  "Proposer",
  "Bank",
  "Review",
  "Documents",
];

export default function ProgressBar({ step }) {
  const cappedStep = Math.min(step, TOTAL_STEPS - 1);
  const pct = ((cappedStep + 1) / TOTAL_STEPS) * 100;

  return (
    <div className="w-full" data-testid="progress-bar">
      <div className="flex items-center justify-between mb-3">
        <p
          className="text-xs sm:text-sm font-semibold uppercase tracking-[0.08em] text-muted-brand"
          data-testid="progress-step-label"
        >
          Step {cappedStep + 1} of {TOTAL_STEPS} · {STEP_LABELS[cappedStep]}
        </p>
        <p className="text-xs sm:text-sm font-medium text-secondary-brand">
          {Math.round(pct)}%
        </p>
      </div>
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{ width: `${pct}%` }}
          data-testid="progress-fill"
        />
      </div>
    </div>
  );
}
